"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SOLID_COLOR_CLASS = void 0;
const SOLID_COLOR_CLASS = `is-style-solid-color`;
exports.SOLID_COLOR_CLASS = SOLID_COLOR_CLASS;
//# sourceMappingURL=shared.js.map